import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import PostingsWbApi from '../../../../API/shipment/postingsWb-api';
import { uiChangeWbViewSize } from '../../../../actions/ui';
import { Row } from '../../../../components/Basic/Blocks';
import { Button, CheckButton, ExportExcelFileButton } from '../../../../components/Basic/Buttons';
import { Select } from '../../../../components/Basic/Inputs';
import { H2, Text } from '../../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS, MAP_WB_SKLAD_NAME, MARKETS_MAP, TYPE_BUTTONS } from '../../../../constans';
import { formFullDate } from '../../../../utils';
import WbShipPopUp from './ShipPopUp/index';
import WbTableOrders from './TableOrders';
import WbTableSizes from './TableSizes';

const MAP_WB = {
  'WB-1': 1,
  'WB-2': 2,
  'WB-3': 3,
  'WB-4': 4,
  'WB-5': 5,
  'WB-6': 6,
  'WB-7': 7,
  'WB-1 EKB': 1,
  'WB-2 EKB': 2,
  'WB-3 EKB': 3,
  'WB-4 EKB': 4,
  'WB-5 EKB': 5,
  'WB-6 EKB': 6,
  'WB-7 EKB': 7,
  'WB-1_EKB': 1,
  'WB-2_EKB': 2,
  'WB-3_EKB': 3,
  'WB-4_EKB': 4,
  'WB-5_EKB': 5,
  'WB-6_EKB': 6,
  'WB-7_EKB': 7,
};

const WbOrdersPage = () => {
  const { shop, skladName, customerType } = useOutletContext();


  const dispatch = useDispatch();
  const [postings, setPostings] = useState([]);
  const [map, setMap] = useState({});
  const { is_check_size } = useSelector((store) => store.ui);

  const [supplies, setSupplies] = useState([]);
  const [supplie, setSupplie] = useState('');

  const [shipped, setSipped] = useState(false);
  const [showShipment, setShowShipment] = useState(false);

  const loadOrdersNew = async () => {
    await PostingsWbApi.getOrders({
      data: {
        customerType,
        shop: skladName !== 'Не выбран' ? undefined : MARKETS_MAP[shop],
        skladName: skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : MAP_WB_SKLAD_NAME[shop],
      }
    }).then((d) => {
      setPostings(d.postings);
      setMap(d.cardsMapByShop);
    });
  };

  const calcDownloadedData = useCallback(() => {
    let d = postings;

    d = d.map((item) => {
      const mapByShop = map[item.shop];
      const name = mapByShop[item.offer_id] ? mapByShop[item.offer_id].name : '';
      const price = mapByShop[item.offer_id] ? mapByShop[item.offer_id].prices.price : '';
      // const id = mapByShop[item.offer_id] ? mapByShop[item.offer_id].id : '';

      const offer_id = mapByShop[item.offer_id] ? mapByShop[item.offer_id].offer_id : '';

      return {
        Магазин: item.shop,
        'Город отгрузки': skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : MAP_WB_SKLAD_NAME[shop],
        'Номер задания': item.order_id,
        'Дата создания': item.date_created,
        'Название товара': name,
        'Артикул продавца': offer_id,
        // 'Артикул товара': id,
        Количество: 1,
        Цена: price,
        'Rid номер': item.id,
      };
    });

    const r = [...d];

    return r;
  }, [postings, map]);

  const calcDownloadedDataProvider = useCallback(() => {
    let d = postings;

    d = d.map((p) => {
      const item = map[p.offer_id];

      const name = item ? item.name : '';
      const sku = item ? item.offer_id : '';
      const provider = item ? item.provider : '';
      const quantity = item ? item.quantity : '';
      const providerSku = item ? item.providerSku : '';
      const category_0 = item ? item.class : '';
      const category = item ? item.category : '';
      const purchase = item ? item.purchase : '';

      return {
        Магазин: MARKETS_MAP[shop],
        Артикул: sku,
        Наименование: name,
        Поставщик: provider,
        'Количество в заказе': quantity,
        'Артикул поставщика': providerSku,
        'Цена закупки': purchase,
        Штрихкод: p.barcode,
        Категория: category_0,
        Предмет: category,
      };
    });

    const r = [...d];

    return r;
  }, [postings, map]);

  const loadSupplies = async () => {
    // let city = { "msk": "Москва", "ekb": "Екатеринбург" }[MAP_WB_SKLAD_NAME[shop]];
    PostingsWbApi.getShipments({
      data: {
        shop: skladName !== 'Не выбран' ? undefined : MARKETS_MAP[shop],
        isActive: true,
        customerType,
        skladName: skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : MAP_WB_SKLAD_NAME[shop],
      }
    }).then((data) => {
      const d = data.supplies;
      setSupplies(d);
      setSupplie(d[0] || '');
    });
  };

  const shippedOrders = async (shipmentId, orderId) => {
    await PostingsWbApi.moveOrdersToShipment({
      data: {
        shop: skladName !== 'Не выбран' ? undefined : MARKETS_MAP[shop],
        orders: postings,
        supplierName: supplie,
        orderId,
        shipmentId,
      }
    }).then(() => loadOrdersNew());

    setSipped(false);
    await loadOrdersNew(shop);
  };

  useEffect(() => {
    loadOrdersNew();
    loadSupplies();

    // return () => {
    //   dispatch(addWbOrdersMap({}));
    // };
  }, [shop, skladName, customerType]);

  return (
    <>
      <Row style={{ marginBottom: '20px', alignItems: 'flex-end', height: '50px' }}>
        <ExportExcelFileButton
          sheets={['Заказы', 'Товары']}
          filename={`Товары ${skladName !== 'Не выбран' ? MAP_SKLAD_RUS[skladName] : MAP_WB_SKLAD_NAME[shop]}-wb${MAP_WB[shop]
            } - ${postings.length}  (${formFullDate(new Date())})`}
          data={{
            Заказы: calcDownloadedData(),
            // Товары: calcDownloadedDataProvider(),
          }}
          buttonTitle="Скачать список заказов"
        />
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={!supplie}
          // onClick={shipOrders}
          onClick={() => setSipped(true)}
          style={{ margin: '0 15px' }}
        >
          Собрать
        </Button>

        <Select
          label={'Активная поставка'}
          width={'320px'}
          select={supplie}
          onSelect={(v) => setSupplie(v)}
          list={supplies}
        // valueFn={(item) => item.name}
        />
      </Row>

      <Row spaceBetween={true}>
        <H2 style={{ marginBottom: '10px' }}>Всего заказов: {postings.length} </H2>
        <Row style={{ width: 'auto' }}>
          <CheckButton
            checked={is_check_size}
            onSelect={() => dispatch(uiChangeWbViewSize(!is_check_size))}
            style={{ marginRight: '15px' }}
          />
          <Text style={{ marginTop: '4px' }}>Проверка габаритов</Text>
        </Row>
      </Row>
      {is_check_size ? (
        <WbTableSizes skladName={MAP_SKLAD_RUS[skladName]} postings={postings} map={map} shop={shop} setMap={setMap} />
      ) : (
        <WbTableOrders skladName={MAP_SKLAD_RUS[skladName]} postings={postings} map={map} shop={shop} />
      )}
      {shipped && (
        <WbShipPopUp
          skladName={skladName}
          market={shop}
          clickOk={shippedOrders}
          close={() => setSipped(false)}
        />
      )}
    </>
  );
};

export default WbOrdersPage;
